const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;

export function getApiBaseUrl() {
  return apiBaseUrl?.trim() || "/api";
}
